<div class="overflow-hidden rounded-lg bg-white dark:bg-gray-900/20 shadow-sm">
  <img [src]="listing().primaryImage" [alt]="listing().vls" width="651" height="368" />

  <div class="px-4 py-5 sm:px-6 sm:py-6">
    <app-listing-details-info [listing]="listing()" />

    <div
      aria-hidden="true"
      class="w-full border-t border-gray-200 dark:border-gray-700 mt-6 mb-4"
    ></div>

    <app-listing-details-actions
      [listing]="listing()"
      [listingSaved]="listing().savedItemId ? true : false"
    />

    <div
      aria-hidden="true"
      class="w-full border-t border-gray-200 dark:border-gray-700 mt-4 mb-4"
    ></div>

    <div>
      Dreaming of building a home to fit your new Villages lifestyle & passions? We make it easy!
      Begin with your favorite floor plan, choose the ideal location & homesite, then our team of
      professionals at The Villages Design Center, “Street of Dreams” will help make your dream home
      a reality. For more information, give us a call today at
      <a href="tel:352-753-6655">352-753-6655</a>.
    </div>
  </div>
</div>

@if (stateService.community() !== 'middleton') {
  <app-listing-details-village-details [listing]="listing()" />
}

@if (listing().willAccommodate?.models?.length) {
  <app-listing-details-will-accommodate [listing]="listing()" />
}

@if (listing().features) {
  <app-listing-details-features-details [listing]="listing()" />
}
